import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { CommentSubject } from "../../constants";
import { useSignalR } from "../../hooks";
import { queryKeys, useGetIssueFeed } from "../../http";
import { Feed } from "./Feed";

interface IProps {
  issueGuid: string;
  issueCreatedByUserGuid?: string;
  teamSlug?: string;
}

const IssueFeed = (props: IProps) => {
  const { isLoading, data } = useGetIssueFeed(props.issueGuid);
  const queryClient = useQueryClient();
  const signalR = useSignalR();

  useEffect(() => {
    const handleShouldRefetchComments = (issueGuid: string) => {
      queryClient.invalidateQueries(queryKeys.issues.getIssueFeed(issueGuid));
    };

    signalR.onShouldRefetchComments(handleShouldRefetchComments);
    return () => signalR.offShouldRefetchComments(handleShouldRefetchComments);
  }, [queryClient, signalR]);

  function refetchIssueData() {
    if (props.teamSlug) {
      signalR.sendRefetchTeamIssues(props.teamSlug);
      queryClient.invalidateQueries(queryKeys.issues.getIssues(props.teamSlug, undefined));
    }

    if (props.issueCreatedByUserGuid) {
      signalR.sendRefetchUserIssues(props.issueCreatedByUserGuid);
      queryClient.invalidateQueries(queryKeys.issues.getIssues(undefined, props.issueCreatedByUserGuid));
    }

    signalR.sendRefetchIssue(props.issueGuid);
  }

  return (
    <Feed
      subjectType={CommentSubject.Issue}
      subjectGuid={props.issueGuid}
      isLoading={isLoading}
      items={data?.feed ?? []}
      onCommentCreated={() => {
        refetchIssueData();
      }}
      onCommentDeleted={() => {
        refetchIssueData();
      }}
    />
  );
};

export { IssueFeed };
